<template>
  <div>
    <PageHeader :gradientType="gradientType" />
    <PageContent>
      <template #filterBar>
        <form @submit.prevent="applyFilter">
          <h6 class="heading-small text-muted mb-4">Search</h6>
          <div class="row">
            <div class="col">
              <a-input placeholder="Search by" v-model="search">
                <a-select
                  slot="addonAfter"
                  default-value="batch_number"
                  style="width: 90px"
                  v-model="searchType"
                  @change="searchTypeOnChange"
                >
                  <a-select-option value="batch_number">
                    Batch #
                  </a-select-option>
                  <a-select-option value="site"> Site Name </a-select-option>
                </a-select>
              </a-input>
            </div>
          </div>
        </form>
        <hr />
        <form role="form" @submit.prevent>
          <div>
            <div>
              <h6 class="heading-small text-muted mb-4">Filter by Status</h6>
            </div>
            <div class="row mb-3">
              <div class="col">
                <a-select
                  v-model="table.filters.status"
                  show-search
                  mode="multiple"
                  optionFilterProp="children"
                >
                  <a-select-option value="For Approval"
                    >For Approval (Pending)</a-select-option
                  >
                  <a-select-option value="For Receive Order"
                    >For Receive</a-select-option
                  >
                  <a-select-option value="Posted Order"
                    >Posted (Received)</a-select-option
                  >
                  <a-select-option value="Rejected">Rejected</a-select-option>
                </a-select>
              </div>
            </div>
          </div>

          <div>
            <div>
              <h6 class="heading-small text-muted mb-4">
                Filter by Membership Program
              </h6>
            </div>
            <div class="row mb-3">
              <div class="col">
                <a-select
                  v-model="table.filters.membership_program_id"
                  show-search
                  optionFilterProp="children"
                >
                  <a-select-option :value="null">All</a-select-option>
                  <a-select-option
                    v-for="membershipProgram in options.membershipPrograms"
                    v-bind:value="membershipProgram.id"
                    v-bind:key="membershipProgram.id"
                  >
                    {{ membershipProgram.name }}
                  </a-select-option>
                </a-select>
              </div>
            </div>
          </div>
          <div>
            <div>
              <h6 class="heading-small text-muted mb-4">
                Filter by Card Types
              </h6>
            </div>
            <div class="row mb-3">
              <div class="col">
                <a-select
                  v-model="table.filters.card_type_id"
                  show-search
                  mode="multiple"
                  optionFilterProp="children"
                >
                  <a-select-option
                    v-for="cardType in options.cardTypes"
                    v-bind:value="cardType.id"
                    v-bind:key="cardType.id"
                  >
                    {{ cardType.name }}
                  </a-select-option>
                </a-select>
              </div>
            </div>
          </div>
          <div class="row">
            <div class="col">
              <base-button
                type="primary btn-block"
                class="my-4"
                @click.prevent="applyFilter"
              >
                <div>Apply Filter</div>
              </base-button>
            </div>
          </div>
        </form>
      </template>

      <template #pageTable>
        <PageTable
          :tableTitle="table.title"
          :apiUrl="table.apiUrl"
          :tableFields="table.fields"
          :appendedParams="table.filters"
          :sortOrder="table.sortOrder"
        >
          <template #headerButtons>
            <base-button
              id="new"
              v-if="selectedActions.includes('Add')"
              class="float-right ml-1"
              type="primary"
              size="sm"
              @click="openDrawer()"
              >+ Add Card Order</base-button
            >
          </template>

          <template #formDrawer>
            <a-drawer
              :width="drawer.width"
              :placement="drawer.placement"
              :visible="drawer.visible"
              @close="closeDrawer"
            >
              <CardOrderForm
                :viewMode="viewMode"
                :cardOrderData="cardOrderData"
                @closeDrawer="closeDrawer"
                :selectedActions="selectedActions"
              />
            </a-drawer>

            <a-drawer
              :key="keyCheck"
              :width="detailDrawer.width"
              :placement="detailDrawer.placement"
              :visible="detailDrawer.visible"
              @close="closeDetailDrawer"
            >
              <CardOrderDetail
                :viewMode="viewMode"
                :cardOrderData="cardOrderData"
                @closeDrawer="closeDetailDrawer"
                :selectedActions="selectedActions"
              />
            </a-drawer>
          </template>

          <template #tableButtons="{ tableProps }">
            <button
              id="view"
              v-if="
                selectedActions.includes('View') &&
                tableProps.rowData.cardOrderStatus.name != 'For Approval'
              "
              class="btn btn-success btn-sm"
              @click.prevent="openDetailDrawer(tableProps.rowData)"
            >
              View
            </button>

            <button
              id="view"
              v-if="
                selectedActions.includes('View') &&
                tableProps.rowData.cardOrderStatus.name == 'For Approval'
              "
              class="btn btn-success btn-sm w-100"
              @click.prevent="openDrawer(tableProps.rowData)"
            >
              View
            </button>

            <button
              v-if="
                tableProps.rowData.cardOrderStatus.name != 'For Approval' &&
                selectedActions.includes('Export to Excel')
              "
              class="btn btn-warning btn-sm"
            >
              <downloadexcel
                :fetch="
                  () => {
                    return fetchJsonData(tableProps.rowData.batch_number);
                  }
                "
                :escapeCsv="false"
                :fields="excelExportOpts.jsonFields"
                :type="excelExportOpts.filetype"
                :name="excelExportOpts.filename"
                :before-generate="beforeGenerateData"
              >
                <span>Export to excel</span>
              </downloadexcel>
            </button>

            <!-- <downloadexcel
              :fetch="fetchJsonData(tableProps.rowData.id)"
              :fields="excelExportOpts.jsonFields"
              :type="excelExportOpts.filetype"
              :name="excelExportOpts.filename"
              :before-generate="beforeGenerateData"
            >
              <i class="fa fa-download"></i> <span>Export to excel</span>
            </downloadexcel> -->
          </template>
        </PageTable>
      </template>
    </PageContent>
  </div>
</template>

<script>
import PageHeader from '../../components/Page/Header.vue';
import PageContent from '../../components/Page/Content.vue';
import PageTable from '../../components/Page/Table.vue';
import CardOrderForm from './CardOrderForm.vue';
import CardOrderDetail from './CardOrderDetail.vue';
import downloadexcel from 'vue-json-excel';
import HTTPRequest from '../../controllers/httpRequest';
import secureStorage from '../../controllers/secureStorage';
import { mapGetters } from 'vuex';

export default {
  components: {
    PageHeader,
    PageContent,
    PageTable,
    CardOrderForm,
    downloadexcel,
    CardOrderDetail
  },
  data() {
    return {
      keyCheck: 1,
      // selectedActions: [],
      gradientType: 'gradient-teal',
      searchType: 'batch_number',
      search: null,
      cardOrderData: null,
      drawer: {
        visible: false,
        width: 480,
        placement: 'right'
      },
      detailDrawer: {
        visible: false,
        width: 1100,
        placement: 'right'
      },
      viewMode: false,
      table: {
        title: 'Card Orders',
        apiUrl:
          '/api/v1/clp_card_orders?origin_site_id=' +
          secureStorage.getItem('currentSiteId'),
        fields: [
          'actions',
          { name: 'batch_number', title: 'Batch Number' },
          { name: 'cardOrderStatus.name', title: 'Status' },
          { name: 'site.name', title: 'Target Site' },
          { name: 'card_number_from', title: 'Serial # From' },
          { name: 'card_number_to', title: 'Serial # To' },
          { name: 'membershipProgram.name', title: 'Membership Program' },
          { name: 'membershipLevel.name', title: 'Membership Level' },
          { name: 'cardType.name', title: 'Card Type' },
          { name: 'quantity', title: 'Quantity' }
        ],
        filters: {
          status: [],
          batch_number: null,
          site: null,
          card_type_id: [],
          card_status_id: [],
          membership_program_id: null,
          hasFilter: true
        },
        sortOrder: [
          {
            field: 'id',
            direction: 'desc'
          }
        ]
      },

      radio: {
        style: {
          display: 'block',
          height: '35px',
          lineHeight: '30px'
        }
      },

      options: {
        cardStatuses: [],
        membershipPrograms: [],
        cardTypes: []
      },

      excelExportOpts: {
        jsonFields: {
          card_no: 'card_number',
          barcode: 'barcode',
          serial_no: 'serial_no',
          card_type: 'cardType.name'
        },
        filetype: 'csv',
        filename: 'card-order.csv'
      }
    };
  },
  computed: {
    ...mapGetters({
      selectedActions: 'getModuleSelectedActions'
    })
  },
  methods: {
    openDrawer(rowData = null) {
      this.viewMode = event.target.id == 'view' ? true : false;
      this.cardOrderData = rowData;
      this.drawer.visible = true;
    },

    async openDetailDrawer(rowData = null) {
      this.viewMode = event.target.id == 'view' ? true : false;
      this.cardOrderData = rowData;

      //Call endpoint for card details and summary
      const response = await HTTPRequest.getRequest(
        '/api/v1/clp_card_orders/' +
          this.cardOrderData.batch_number +
          '/card_details'
      );
      this.cardOrderData.fullCardDetails = response;
      this.keyCheck++;
      this.detailDrawer.visible = true;
    },

    closeDrawer() {
      this.drawer.visible = false;
      this.cardOrderData = null;
    },

    closeDetailDrawer() {
      this.detailDrawer.visible = false;
      this.cardOrderData = null;
    },

    async getCardStatuses() {
      const response = await HTTPRequest.getRequest(
        '/api/v1/clp_card_statuses'
      );
      this.options.cardStatuses = response.data;
    },

    async getMembershipPrograms() {
      const response = await HTTPRequest.getRequest(
        '/api/v1/clp_membership_programs'
      );
      this.options.membershipPrograms = response.data.sort((a, b) =>
        a.name.localeCompare(b.name)
      );
    },

    searchTypeOnChange() {
      this.table.filters = {
        batch_number: null,
        site: null
      };
      this.table.filters[this.searchType] = this.search;
    },
    async getCardTypes(membershipProgramId) {
      const data = await HTTPRequest.getRequest(
        `/api/v1/clp_membership_programs/${membershipProgramId}/card_types`
      );
      this.options.cardTypes = data.sort((a, b) =>
        a.name.localeCompare(b.name)
      );
    },
    applyFilter() {
      if (
        this.table.filters['membership_program_id'] == null &&
        this.table.filters['status'] &&
        this.table.filters['card_type_id'] &&
        this.table.filters['card_type_id'].length == 0 &&
        this.table.filters['status'].length == 0 &&
        this.table.filters['batch_number'] == null &&
        this.table.filters['site'] == null
      ) {
        this.table.filters.hasFilter = false;
      } else {
        this.table.filters.hasFilter = true;
      }
      this.setFilter();
    },

    setFilter() {
      this.$root.$emit('refreshTable');
    },

    async fetchJsonData(cardOrderId) {
      const data = await HTTPRequest.getRequest(
        '/api/v1/clp_card_orders/' + cardOrderId + '/cards'
      );

      return data;
    },

    beforeGenerateData() {
      this.$message.loading('Generating data', 1);
    }
  },

  created() {
    this.$store.dispatch('setCurrentModule', 'CardOrder');
    this.getCardStatuses();
    this.getMembershipPrograms();
  },

  mounted() {
    this.selectedActions = this.$store.getters.getModuleSelectedActions;
  },

  watch: {
    search(val) {
      if (val == '') {
        this.search = null;
      } else {
        this.table.filters.hasFilter = true;
      }
      this.table.filters[this.searchType] = val;
    },
    'table.filters.membership_program_id': function (val) {
      if (val == null) {
        this.options.cardTypes = [];
      } else {
        this.getCardTypes(val);
      }
    }
  }
};
</script>

<style scoped></style>
